import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";

class MetricOutbidRatio extends MetricBase {
    constructor() {
        super({
            field: "metric_outbid_ratio",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.trivago.outbidRatio.chartName"),
            serieLabel: i18n.t("metrics.trivago.outbidRatio.serieLabel"),
            tooltip: i18n.t("metrics.trivago.outbidRatio.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricOutbidRatio;
